import { ReactNode } from 'react';
import { CardId } from '../../../organisms/analytics/generalOverview/types';

export enum CardTheme {
  ORANGE = 'orange',
  GREEN = 'green',
  BLUE = 'blue',
  BLUE_LIGHT = 'blue_light',
  NEUTRAL = 'neutral',
  PURPLE = 'purple',
  PURPLE_LIGHT = 'purple_light',
  PINK = 'pink',
  RED = 'RED',
  TEAL = 'teal',
}

export enum ChartType {
  LINE = 'line',
  BAR = 'bar',
}

export interface ICardAnalyticItemProps {
  id: CardId;
  title: string | ReactNode;
  cardTitle?: ReactNode;
  count: ReactNode;
  icon: string;
  theme: CardTheme;
  chartType: ChartType;
  unit: string;
  filteredCount?: ReactNode;
}

export interface MetricConfig {
  title: string | ReactNode;
  icon: string;
  totalCount: number;
  totalAmount: number;
  filteredCount: number;
  filteredAmount: number;
  unit: string;
  theme: CardTheme;
  currency: string;
  isIncludeFilter?: boolean;
  customHeader?: ReactNode;
  customBody?: ReactNode;
  isIncludeAmout?: boolean;
  isNetAmount?: boolean;
}

export interface ICardSelectorProps {
  selectedCards: ICardAnalyticItemProps[];
  setSelectedCards: React.Dispatch<React.SetStateAction<ICardAnalyticItemProps[]>>;
  onCardSelected?: (id: CardId) => void;
  children: ReactNode;
}
